import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_text_field_with_date_picker = _resolveComponent("text-field-with-date-picker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialogShown,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogShown) = $event)),
    width: "25vw"
  }, {
    activator: _withCtx(({ on, attrs }) => [
      _createVNode(_component_v_btn, _mergeProps(attrs, {
        class: 'ml-4 zamg-button' + (_ctx.outlined ? ' zamg-button-secondary' : ''),
        "data-testid": _ctx.testid,
        color: "primary",
        disabled: _ctx.disabled,
        small: ""
      }, _toHandlers(on), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogShown = true))
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "download-icon" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" mdi-download ", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }, 16, ["class", "data-testid", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, {
            "data-testid": `${_ctx.testid}-card-title`,
            class: "text-uppercase zamg-text-continuous"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.title + ' ' + _ctx.t('download_form.to_download')), 1)
            ]),
            _: 1
          }, 8, ["data-testid"]),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.showDatePicker)
                ? (_openBlock(), _createBlock(_component_text_field_with_date_picker, {
                    key: 0,
                    value: _ctx.startDate,
                    label: _ctx.t('start_date'),
                    testid: 'download-dialog-start-date',
                    "allowed-date-range": [
            _ctx.datasetStore.metadata?.startDate,
            _ctx.datasetStore.metadata?.endDate,
          ],
                    "show-hint": true,
                    "text-field-props": {
            ..._ctx.datePickerTextFieldProps,
            filled: true,
          },
                    "selected-date-is-start-date": true,
                    "reference-date": _ctx.endDate,
                    onDateSelected: _ctx.setStartDate
                  }, null, 8, ["value", "label", "allowed-date-range", "text-field-props", "reference-date", "onDateSelected"]))
                : _createCommentVNode("", true),
              (_ctx.showDatePicker)
                ? (_openBlock(), _createBlock(_component_text_field_with_date_picker, {
                    key: 1,
                    value: _ctx.endDate,
                    label: _ctx.t('end_date'),
                    testid: 'download-dialog-end-date',
                    "allowed-date-range": [
            _ctx.datasetStore.metadata?.startDate,
            _ctx.datasetStore.metadata?.endDate,
          ],
                    "show-hint": true,
                    "text-field-props": {
            ..._ctx.datePickerTextFieldProps,
            filled: true,
          },
                    "selected-date-is-start-date": false,
                    "reference-date": _ctx.startDate,
                    onDateSelected: _ctx.setEndDate
                  }, null, 8, ["value", "label", "allowed-date-range", "text-field-props", "reference-date", "onDateSelected"]))
                : _createCommentVNode("", true),
              (_ctx.showDatePicker)
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 2,
                    modelValue: _ctx.addDownloadRangeToFilename,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addDownloadRangeToFilename) = $event)),
                    class: "mb-4 ml-2 mt-0 pt-0",
                    disabled: _ctx.startDate === null || _ctx.endDate === null,
                    "hide-details": true,
                    density: "compact"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("span", {
                        id: "checkboxLabel",
                        "data-testid": "add-download-range-to-filename",
                        class: _normalizeClass(
                'zamg-text-small-continuous' +
                  (_ctx.startDate === null || _ctx.endDate === null
                    ? ' zamg-text-disabled'
                    : ' zamg-text-input')
              )
                      }, _toDisplayString(_ctx.t('download_form.add_download_range')), 3)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.fileName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fileName) = $event)),
                class: "mb-3",
                label: _ctx.t('download_form.download_file_name'),
                variant: "filled",
                "persistent-hint": "",
                "data-testid": `${_ctx.testid}-download-file-name-input`,
                hint: 'overridden by slot',
                onInput: _cache[3] || (_cache[3] = (event) => _ctx.onUserInput(event.target.value))
              }, {
                message: _withCtx(() => [
                  (_ctx.fileName !== '')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        "data-testid": `${_ctx.testid}-download-file-name-label`,
                        class: "zamg-text-input"
                      }, _toDisplayString(_ctx.t('download_form.file_name_hint')) + ": ", 9, _hoisted_1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    "data-testid": `${_ctx.testid}-download-file-name-result`
                  }, _toDisplayString(_ctx.fileName === ''
                  ? _ctx.t('download_form.file_name_error_message')
                  : _ctx.resultingFilename), 9, _hoisted_2)
                ]),
                _: 1
              }, 8, ["modelValue", "label", "data-testid"]),
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedFormat,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedFormat) = $event)),
                items: _ctx.formatChoices,
                label: _ctx.t('format'),
                "hide-details": "",
                variant: "filled"
              }, null, 8, ["modelValue", "items", "label"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pb-4 px-6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "outlined",
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('abort')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn, {
                class: "ml-4 primary",
                color: "primary",
                variant: "elevated",
                "data-testid": `${_ctx.testid}-download-data`,
                disabled: 
            _ctx.fileName === '' ||
              ((_ctx.startDate === null || _ctx.endDate === null) && _ctx.showDatePicker) ||
              _ctx.disableDownloadButton
          ,
                onClick: _ctx.triggerDownload
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('download_form.to_download')), 1)
                ]),
                _: 1
              }, 8, ["data-testid", "disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}